import {PartialGameDomainModel} from "./partial-game-domain-model";
import {ResourceRequestParams} from "../../../infrastructure/models/params/resource-request-params";
import {ARGS} from "../../../core/bootstrap/args";

export class GameImageRequestParams extends ResourceRequestParams {
  game: PartialGameDomainModel;

  constructor(game: PartialGameDomainModel) {
    super(ARGS.NOTIFICATIONS_IMAGES_API_APPSPOT);

    this.game = game;
  }

  toString(): String {
    return `${this.baseUrl}?game_id=${this.game.id}&lang=1`;
  }
}
